// extracted by mini-css-extract-plugin
export default {"root":"MultiSelectDesktop_root--zmF","contentClass":"MultiSelectDesktop_contentClass--RVC"};